import { useEffect, useState } from "react";
import useUserData from "./user/useUserData";
import { useTranslation } from "react-i18next";
import { PAGE_LOGIN } from "../locales/pages/namespaces";
import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { handleAxiosErrors } from "../helpers/errorHandling";
import { API } from "../helpers/constants";
import {normalizeProductKeepLang} from "../helpers/products/normalizeProduct";

const useProduct = ({id}) => {
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState(null);
    const [error, setError] = useState(null);

    const { token } = useUserData();
    const { t } = useTranslation(PAGE_LOGIN);

    useEffect(() => {
        if (!id) {
            setProducts(null);
            return;
        }
        setLoading(true);
        axios({
            method: "post",
            url: `${API}/en/brew/item/details`,
            headers: {
                "Content-Type": "application/json", Authorization: `Bearer ${token}`  ,
            },
            data: {
                ItemId: id,
            },
        })
            .then((res) => {
                setProducts(normalizeProductKeepLang(res.data));
            })
            .catch((error) => {
                enqueueSnackbar(handleAxiosErrors(error, t("An error occurred!")), {
                    variant: "error",
                    autoHideDuration: 3000,
                });
            })
            .finally(() => {
                setLoading(false);
            });
    }, [id, token, t]);


    return {
        loading,
        product:products,
        error,
    };
};

export default useProduct;